export var indicatorHasValue = function (indicator) {
  var result = indicator.result || {};
  var unit = indicator.unit || {};
  var value = result.value,
    _a = result.description,
    description = _a === void 0 ? {} : _a;
  var valueType = (unit === null || unit === void 0 ? void 0 : unit.valueType) || {};
  if ((valueType === null || valueType === void 0 ? void 0 : valueType.name) === 'description') {
    return !!(description === null || description === void 0 ? void 0 : description.text);
  }
  return value !== null && value !== undefined;
};